<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb56></breadcrumb56>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <!-- Basic Information -->
                  <i class="fa fa-arrow-left fa-lg ml-md-4" aria-hidden="true" style="background-color:black; color:white;padding:10px;border-radius:100%; cursor: pointer;" @click="goBack"></i>
                  <div class="row mt-2 ml-md-2">
                    <div class="col-md-12" id="patient_container">
                      <table class="table-responsive">
                        <thead>
                          <tr>
                            <th style="background-color: #F8F8F8;" class="text-left column-name">Title of Investigation
                            </th>
                            <th style="background-color: #F8F8F8;" class="text-left column-description">Description</th>
                            <th style="background-color: #F8F8F8;" class="text-left column-action">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in all_investigation_template" :key="index" v-bind:key="index"
                            v-show="setPaginate(index)">
                            <td class="text-left">
                              {{ all_investigation_template[index].template_name }}
                            </td>
                            <td class="text-left">
                              <div v-html="formatDescription(all_investigation_template[index].description)"></div>
                              <!-- {{ all_investigation_template[index].description }} -->
                            </td>
                            <td class="text-left">
                              <a href="#graph4" class="btn btn-sm bg-warning-light" data-toggle="modal"
                                @click="editInvestigation(item)">
                                <i class="fas fa-edit"></i> Edit</a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <h5 v-if="all_investigation_template.length === 0 && !showspinner
                        " class="No_data">
                        No Investigation Template Found
                      </h5>
                      <!-- pagination start -->
                      <div id="pagination" class="ml-3" v-if="all_investigation_template.length > 10">
                        <ul class="pagination justify-content-center">

                          <!-- "Previous" Button -->
                          <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                            <a href="#" class="page-link" aria-label="Previous"
                              @click.prevent="updateInvestigationCount(current - 1)">
                              Previous
                            </a>
                          </li>

                          <!-- Pagination Links (Display 5 at a time) -->
                          <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                            'page-item',
                            current === page_index ? 'active' : ''
                          ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                            <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                              {{ page_index }}
                            </a>
                          </li>

                          <!-- "Next" Button -->
                          <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                            ">
                            <a href="#" class="page-link" aria-label="Next"
                              @click.prevent="updateInvestigationCount(current + 1)">
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                      <!-- pagination end -->
                    </div>
                  </div>
                  <!-- /Basic Information -->
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>
      <div class="modal fade custom-modal show" id="graph4">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Update Investigation
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Template Name <span class="No_data">*</span></label>
                        <input v-model="investigation_data.template_name" type="text" class="form-control" value=""
                          oninput="this.value = this.value.replace(/[^a-zA-Z ]/g, '');" />
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="form-group">
                        <label>Description</label>
                        <textarea id="PatientWording" name="PatientWording" rows="5" cols="50" class="form-control"
                          v-model="investigation_data.description" value="">
                                </textarea>
                      </div>
                    </div>
                  </div>
                  <div class="submit-section" style="text-align:left">
                    <button :disabled="disabled" @click="update_investigation()" class="btn btn-primary submit-btn"
                      data-dismiss="modal" aria-label="Close">
                      Update Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../../services/CommonApi";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showspinner: false,
      all_investigation_template: [],

      investigation_data: {
        name: "",
        template_name: "",
        description: ""
      },
      current: 1,
      paginate: 10,
      paginate_total: 0,
    };
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),
  },
  methods: {

    close() {
      window.location.reload();
    },
    goBack() {
            // Go one page back
            this.$router.go(-1);
        },

    formatDescription(description) {
      return description.replace(/\n/g, '<br>');
    },
    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    editInvestigation(data) {
      (this.editInvestigation = true),
        (this.investigation_data.name = data.name),
        (this.investigation_data.template_name = data.template_name),
        (this.investigation_data.description = data.description)
    },

    /* Add Dependent  */
    async update_investigation() {
      if (!this.disabled) {
        this.$swal({
          text: "Adding Investigation...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        // var data = new FormData();
        let data = {
          name: this.investigation_data.name,
          template_name: this.investigation_data.template_name,
          description: this.investigation_data.description
        }


        if (this.editPrescription) {
          let objIndex = this.all_investigation_template.findIndex(
            (obj) => obj.name === this.investigation_data.name
          );
          this.all_investigation_template[
            objIndex
          ].template_name = this.investigation_data.template_name;
          this.all_investigation_template[
            objIndex
          ].description = this.investigation_data.description;

        } else {
          this.all_investigation_template.push(this.investigation_data);
        }
        this.all_investigation_template = this.all_investigation_template.map(
          ({ template_name, ...rest }) => ({ ...rest })
        );
        await CommonApi.post_data(
          "sahaj.template.update_templates",
          data
        ).then((res) => {
          this.showspinner = false;
          if (res && res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
          }).then(() => {
            window.location.reload();
          });
            this.get_investigation_advice_templates();
            this.editPrescription = false;
            this.$emit("close");
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
          this.all_investigation_template = [];
          this.investigation_data.template_name = "";
          this.investigation_data.description = "";
        });
      }
    },

    //edit exercise plans
    edit_plan_details(id) {
      this.$router.push(`/doctor/edit-exercise-plan/${id}`);
    },
    /* Get All Excercise Plane Details */


    async get_investigation_advice_templates() {
      const params = new URLSearchParams();
      params.append("doctor", this.user_id);
      await CommonApi.get_data(
        "sahaj.template.get_investigation_advice_templates",
        params
      ).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.all_investigation_template = res.data;
          this.paginate_total = Math.ceil(
            this.all_investigation_template.length / this.paginate
          );
        }
      });
    },
  },
  mounted() {
    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }
    this.get_investigation_advice_templates();
  },
};
</script>

<style scoped>
/* Default column widths */
.column-name {
  min-width: 200px;
}

.column-description {
  min-width: 600px;
  /* Adjusted to take more width */
}

.column-action {
  min-width: 90px;
}

/* Responsive column widths for smaller screens */
@media (max-width: 768px) {
  .column-name {
    min-width: 250px;
  }

  .column-description {
    min-width: 400px;
  }

  .column-action {
    min-width: 70px;
  }
}

/* Responsive column widths for even smaller screens */
@media (max-width: 480px) {
  .column-name {
    min-width: 150px;
  }

  .column-description {
    min-width: 250px;
  }

  .column-action {
    min-width: 60px;
  }
}

/* Make columns take full width on desktop */
@media (min-width: 1024px) {

  .column-name,
  .column-description,
  .column-action {
    min-width: 1px;
    /* Set to 1px to allow columns to expand to full width */
    width: 50%;
    /* Set width to 100% to occupy full available width */
  }
}</style>


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Investigation.vue